import { __assign, __rest } from "tslib";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
var send = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 16 16", fill: "currentColor", width: size || "16", height: size || "16" }, props),
        React.createElement("path", { fill: "currentColor", d: "M1.40926391,5.29366938 L15.6697462,0.453934265 C16.3429879,0.239515621 16.9856276,0.882771554 16.7714144,1.55665872 L11.9363152,15.8308142 C11.722102,16.5047013 10.8040452,16.6272263 10.4062206,16.0146016 L7.34603122,11.3280226 L12.057229,5.36657191 C12.2102384,5.1827845 12.0266271,4.9989971 11.8430157,5.15215327 L5.87714034,9.91898584 L1.19505066,6.85586236 C0.613614686,6.42702507 0.705420366,5.53871926 1.40926391,5.29366938 Z", transform: "rotate(-45 12.3 10.382)" })));
};
send.displayName = 'send';
export default send;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=send.js.map